import React, { Suspense } from "react";
import { Spin } from "antd";

const ReferralProgramContainer = React.lazy(
  () => import("../../modules/ReferralProgram/components/index")
);

const ReferralProgramPage = () => (
  <Suspense fallback={<Spin />}>
    <ReferralProgramContainer />
  </Suspense>
);

export default ReferralProgramPage;
